import { useEffect, useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import apiInstance from "../../utils/axios";
import UserData from "../plugins/UserData";
import '../../../css/productIngredients.css';
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useAxios from '../../utils/useAxios'


const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

function ProductIngredients() {

    const [allIngredients, setAllIngredients] = useState([]);
    const [selectedIngredients, setSelectedIngredients] = useState([]);
    const [productIngredientId, setProductIngredientId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [productId, setProductId] = useState(null);
    const [productName, setProductName] = useState('')
    const { t } = useTranslation();

    const {hashedId} = useParams()
    const navigate = useNavigate()
    const api = useAxios();

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

    useEffect(() => {
        if (hashedId) {
            apiInstance.get(`decode-id/${hashedId}/`).then((res) => {
                const decodedId = res.data.id;
                setProductId(decodedId);
            })
            .catch((error) => {
                console.error("Error in retrieving product id", error);
                Toast.fire({
                    icon: "error",
                    title: "Error in retrieving product id",
                })
            })
        };

        apiInstance.get(`/ingredients/`,{headers: { "Accept-Language": `${lang}` }}).then((res) => {
            setAllIngredients(res.data);
        })
        .catch((error) => {
            console.error("Error in retrieving ingredients", error);
            Toast.fire({
                icon: "error",
                title: "Error in retrieving ingredients",
            })
        })

    }, [hashedId, lang]);


    useEffect(() => {
        if (productId) {
            apiInstance.get(`/name-product/${productId}/`).then((res) => {
                setProductName(res.data.product_name.name);
               
            })

            apiInstance.get(`/product_ingredients/${productId}/`)
                .then((response) => {
                    setSelectedIngredients(response.data.ingredient || []);
                    setProductIngredientId(response.data.id || null);
                })
                .catch(error => {
                    console.error("Error in retrieving product ingredients", error);
                    Toast.fire({
                        icon: "error",
                        title: "",
                    })
                })
                .finally();
        }
    }, [productId, lang]);

    // Function to toggle ingredient selection
    const handleToggle = (ingredientId) => {
        setSelectedIngredients((prevSelected) =>
        prevSelected.includes(ingredientId)
            ? prevSelected.filter((id) => id !== ingredientId) // Remove if already selected
            : [...prevSelected, ingredientId] // Add if not selected
        );
    };

    const groupedIngredients = allIngredients.reduce((groups, ingredient) => {
        const typeName = ingredient.ingredient_type.name; // Extract type name
    
        if (!groups[typeName]) {
            groups[typeName] = []; // Create array for this type if not exists
        }
    
        groups[typeName].push(ingredient); // Add ingredient to type group
        
        return groups;
    }, {});
    
    // Sort each group alphabetically by name
    Object.keys(groupedIngredients).forEach(type => {
        groupedIngredients[type].sort((a, b) => a.name.localeCompare(b.name));
    });

    // Function to save ingredients (Create or Update)
    const saveIngredients = () => {
        if (!api) return;
        setIsLoading(true)
        if (productIngredientId) {
        // If ProductIngredients exists, update it
        apiInstance
            .put(`/product_ingredients/${productIngredientId}/`, {
            ingredient: selectedIngredients,
            })
            .then(() => {
                // alert("Ingredients updated successfully!");
                Toast.fire({
                    icon: "success",
                    title: "Ingredients updated successfully!",
                })
                setIsLoading(false)
                navigate(`/product-ingredients-details/${hashedId}/`)
            });

        } else {
        // If ProductIngredients does NOT exist, create it
        setIsLoading(true)
        api
            .post(`/product_ingredients/`, {
            product: productId,
            ingredient: selectedIngredients,
            })
            .then((res) => {
            setProductIngredientId(res.data.id); // Store the new ID
            // alert("Ingredients saved successfully!");
            Toast.fire({
                icon: "success",
                title: "Ingredients saved successfully!",
            })
            setIsLoading(false)
            navigate(`/product-ingredients-details/${hashedId}/`)
            });
        }
    };

  return (
    <>
        <div className="container">
            <p className="form-heading-1">{t("productIngredients.headings.title")}</p>
            <p className="desc-text">{t("productIngredients.headings.description")} <b>{productName}</b>!</p>
            <div className="grid-container-1">
                {Object.entries(groupedIngredients).map(([type, items]) => (
                    <div className="grid-item-1" key={type}>
                    <h4>{type}</h4>
                    {items.map((ingredient) => (
                        <label key={`${type}-${ingredient.id}`}>
                        <input
                            type="checkbox"
                            checked={selectedIngredients.includes(ingredient.id)}
                            onChange={() => handleToggle(ingredient.id)}
                        />
                        <span>{ingredient.name}</span>
                        </label>
                    ))}
                    </div>
                ))}
            </div>
            <div className="form-input-container-3" style={{ textAlign: "right", width: "100%" }}>    
                {isLoading 
                ? <button disabled className="form-button-submit-2"  onClick={saveIngredients}>
                    <i className="fas fa-spinner fa-spin"></i>
                    <span className="mr-2">Processing</span>
                    </button>
                : <button className="form-button-submit-2"  onClick={saveIngredients}><span className="mr-2">Submit</span>
                    </button>
                }
            </div>
        </div>
    </>
  )
}

export default ProductIngredients